var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectNoneHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9497,
    y: 19.7148,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(-45 13.9497 19.7148)",
    fill: "#768F95"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9497,
    y: 9.7561,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(-45 13.9497 9.7561)",
    fill: "#768F95"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.91876,
    y: 19.7148,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(-45 3.91876 19.7148)",
    fill: "#768F95"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.91876,
    y: 9.7561,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(-45 3.91876 9.7561)",
    fill: "#768F95"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.115,
    y: 14.666,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(45 15.115 14.666)",
    fill: "#768F95"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.115,
    y: 4.70728,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(45 15.115 4.70728)",
    fill: "#768F95"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08408,
    y: 14.666,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(45 5.08408 14.666)",
    fill: "#768F95"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08408,
    y: 4.70728,
    width: 7.14,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(45 5.08408 4.70728)",
    fill: "#768F95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectNoneHover);
export default __webpack_public_path__ + "static/media/select-none-hover.286ef6e483951f59009992f1a44dfd35.svg";
export { ForwardRef as ReactComponent };